/**
 * SHA-256 of attachment bytes via SubtleCrypto (browser and Node ≥ 18). Used
 * to recognise the same file uploaded twice and by the Drive archive check.
 */

export type HashInput = Blob | ArrayBuffer | Uint8Array;

function toHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let out = '';
  for (const b of bytes) out += b.toString(16).padStart(2, '0');
  return out;
}

async function toBuffer(input: HashInput): Promise<ArrayBuffer> {
  if (input instanceof ArrayBuffer) return input;
  if (input instanceof Uint8Array) {
    return input.buffer.slice(input.byteOffset, input.byteOffset + input.byteLength) as ArrayBuffer;
  }
  return input.arrayBuffer();
}

/** Lower-case hex SHA-256. */
export async function sha256Hex(input: HashInput): Promise<string> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) throw new Error('SubtleCrypto is not available');
  return toHex(await subtle.digest('SHA-256', await toBuffer(input)));
}

/** True for a 64-char lower-case hex digest. */
export function isSha256Hex(value: string): boolean {
  return /^[0-9a-f]{64}$/.test(value);
}
